export type Mission = {
  id: string,
  title: string,
  subtitle: string,
  description: string,
  buttonTitle?: string,
  buttonURL?: string,
  buttonTarget?: string
}

export const missionList: Array<Mission> = [
  {
    id: '0',
    title: 'Play Houndrace and earn points',
    subtitle: 'Join the first season',
    description: "",
    buttonTitle: 'VIEW LEADERBOARD',
    buttonURL: '/leaderboards'
  },
  {
    id: '1',
    title: 'Breed new hounds and earn points',
    subtitle: 'Join the first breeding season',
    description: "",
    buttonTitle: 'VIEW LEADERBOARD',
    buttonURL: '/leaderboards',
  },
  {
    id: '2',
    title: 'Open your Mystery Box',
    subtitle: 'Claim your prize',
    description: "",
    buttonTitle: 'OPEN NOW',
    buttonURL: 'https://claim.houndrace.com/',
    buttonTarget: '_blank'
  },
  {
    id: '3',
    title: 'Stack up more points on zealy',
    subtitle: 'Complete tasks and earn',
    description: "",
    buttonTitle: 'JOIN ZEALY',
    buttonURL: 'https://zealy.io/cw/alphadune/questboard',
    buttonTarget: '_blank'
  }
];
